<template>
  <v-container fluid>
    <v-row>
      <v-col md="6">
        <highcharts
          ref="chart"
          class="hc"
          :options="options"
        />
      </v-col>
      <v-col
        md="6"
        class="d-flex flex-column align-items-start justify-content-center"
      >
        <p class="d-flex align-items-start small">
          <span
            class=" d-inline-block p-2 rounded-circle mr-1"
            :style="`background-color:${color}`"
          />
          Minha escola: <span class="ml-1 font-weight-bold">{{ schoolAvg }}%</span>
        </p>
        <p class="d-flex align-items-start small">
          <span
            class=" d-inline-block p-2 rounded-circle mr-1"
            :style="{backgroundColor:color,opacity:0.5}"
          />
          Média geral: <span class="ml-1 font-weight-bold">{{ platformAvg }}% </span>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {success_color, danger_color, solidgauge_fill_bg} from "@/constants/colors";

export default {
  name: "TotalFinishedGraphic",
  props: {
    schoolAvg: {
      type: Number,
      required: true,
      default: 0,
    },
    platformAvg: {
      type: Number,
      required: true,
      default: 0,
    },
    diferencial: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  computed: {
    color() {
      return Number(this.diferencial) > 0 ? success_color : danger_color;
    },
    options() {
      return {
        credits: {
          enabled: false
        },
        chart: {
          type: 'solidgauge',
          backgroundColor: null,
          height: '100%',
          renderTo: 'container',
          margin: 0,

        },
        title: false,
        tooltip: {
          distance: 20,
          valueSuffix: '%',
        },
        legend: false,
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              outerRadius: "80%",
              innerRadius: "70%",
              backgroundColor: solidgauge_fill_bg,
              borderWidth: 0
            },
            {
              outerRadius: "110%",
              innerRadius: "100%",
              backgroundColor: solidgauge_fill_bg,
              borderWidth: 0
            }
          ]
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              y: -10,
              borderWidth: 0,
              formatter: () => {
                return `
                        <div style="text-align:center;">
                          <span style="font-weight:bolder;font-size:0.9rem;color:${this.color}">
                          ${this.diferencial === 100 ? this.diferencial : this.diferencial.toFixed(0)}%
                          </span><br/>
                        </div>
                        `
              }
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true,
          }
        },
        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },

        series: [{
          name: 'Média Geral',
          data: [{
            color:  `${this.color}85`,
            radius: '80%',
            innerRadius: '70%',
            y: this.platformAvg
          }]
        }, {
          name: 'Minha Escola',
          data: [{
            color: this.color,
            radius: '110%',
            innerRadius: '100%',
            y: this.schoolAvg
          }],
        }],
      }
    }
  },
}

</script>

<style>
/* Remove o elemento de texto padrão que fica no interno do gráfico */
.highcharts-text-outline {
  display: none;
}
</style>
